import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
const walletVuex = createNamespacedHelpers("wallet");
import { address, toNano } from "@ton/core";
export default {
  name: "mPopSpinsPriceList",
  computed: {
    ...walletVuex.mapState(["tonConnect"]),
    ...userVuex.mapState(["userInfo", "balanceInfo"]),
    ...taskVuex.mapState(["taskInfo"])
  },
  data() {
    return {
      popMoreSpinsShow: false,
      spinsPriceList: null,
      isLoading: false,
      xIndex: 0,
      popPromptInfo: null,
      popPromptShow: false,
      selectItem: null,
      ispay: false,
      payType: null,
      chainInfo: null,
      paymentId: null
    };
  },
  methods: {
    ...userVuex.mapActions(["getSpinsPriceList", "getPaymentSpins", "checkPaymentSpins"]),
    ...taskVuex.mapActions(["openInvoiceStarPay"]),
    async showPopMoreSpins() {
      this.hapticFeedback();
      this.popMoreSpinsShow = true;
      await this.getSpinsPrice();
    },
    async getSpinsPrice() {
      if (this.isLoading) return;
      this.isLoading = true;
      const spinsPriceList = await this.getSpinsPriceList();
      if (!spinsPriceList) {
        this.isLoading = false;
        return;
      }
      this.isLoading = false;
      this.spinsPriceList = spinsPriceList;
    },
    async selectPaySpins(item, index) {
      this.payType = null;
      this.selectItem = item;
      this.selectItem.index = index;
      this.ispay = false;
      this.chainInfo = null;
      this.paymentId = null;
      console.log(this.taskInfo.paymentInfo[`p_${index}`]);
      if (this.taskInfo.paymentInfo[`p_${index}`].isLoading) {
        this.ispay = 1;
        this.paymentId = this.taskInfo.paymentInfo[`p_${index}`].paymentId;
        this.payType = this.taskInfo.paymentInfo[`p_${index}`].payType;
      }
      this.popPromptShow = true;
    },
    async onPaySpins(item, type) {
      this.payType = type;
      let index = item.index;
      this.xIndex = index;
      if (this.taskInfo.paymentInfo[`p_${index}`].isLoading) {
        this.$toasted.clear();
        this.$toasted.info("This item is in transaction, please select another item");
        return;
      }
      console.log("itemitemitemitemitem", item, index);
      if (this.taskInfo.paymentInfo[`p_${index}`].isLoading) return;
      if (type == 1 && !this.tonWallet.uiAddress) {
        this.errorTip = 'Please select wallet address';
        return;
      }
      this.taskInfo.paymentInfo[`p_${index}`].isLoading = true;
      let res;
      if (type == 1) {
        res = await this.getPaymentSpins({
          index,
          currency: 'TON',
          address: this.tonWallet.uiAddress
        });
      } else {
        res = await this.getPaymentSpins({
          index
        });
      }
      if (!res) {
        this.taskInfo.paymentInfo[`p_${index}`].isLoading = false;
        return;
      }
      this.chainInfo = res.chainInfo;
      this.paymentId = res.paymentId ?? 0;
      let payRef = null;
      //console.log("chainInfochainInfochainInfo", res, chainInfo);
      if (type == 0) {
        if (this.chainInfo) {
          payRef = await this.openInvoiceStarPay({
            url: this.chainInfo.payment_url
          });
          console.log("payRef", payRef);
          if (!payRef) {
            this.taskInfo.paymentInfo[`p_${index}`].isLoading = false;
            return;
          } else {
            this.taskInfo.paymentInfo[`p_${index}`].payType = type;
            this.ispay = true;
          }
        } else {}
      } else {
        if (this.chainInfo) {
          let msg = [{
            address: this.chainInfo.contract,
            amount: toNano(this.chainInfo.amount).toString(),
            payload: this.chainInfo.raw
          }];
          console.log("msgmsgmsgmsgmsg", msg);
          try {
            const payRef = await this.tonWallet.sendTransaction(msg);
            console.log("payRef", payRef);
            if (!payRef) {
              this.taskInfo.paymentInfo[`p_${index}`].isLoading = false;
              return;
            } else {
              this.taskInfo.paymentInfo[`p_${index}`].payType = type;
              this.ispay = true;
              return;
            }
          } catch (e) {
            console.log('fail pay');
            this.paymentId = null;
            this.chainInfo = null;
            this.taskInfo.paymentInfo[`p_${index}`].isLoading = false;
            //this.ispay = true
            return;
          }
        } else {}
      }
      console.log("index, paymentIdindex, paymentId", index, this.paymentId);
      const checkRes = await this.checkPaymentSpins({
        index,
        paymentId: this.paymentId
      });
      console.log("checkRescheckRescheckRes", checkRes);
      if (!checkRes) {
        item.isLoading = false;
        return;
      }
      item.isLoading = false;
      this.popPromptShow = false;
      this.popMoreSpinsShow = false;
      this.taskInfo.popCoinAnim.icon = "SPINS";
      this.taskInfo.popCoinAnim.reward = item.count;
      this.taskInfo.popCoinAnim.show = true;
    },
    async onPaySpinsSelect(item, type) {
      this.payType = type;
    },
    onTonConnect() {
      if (!this.tonConnect) {
        this.$nextTick(() => {
          let res = this.tonWallet.openOrCloseTonModal(true);
          this.tonWallet.ton.onStatusChange(async walletAndwalletInfo => {
            if (walletAndwalletInfo) {
              this.doPayment(this.payType);
            }
          });
        });
      }
    },
    async doPayment(type) {
      this.onPaySpins(this.selectItem, type);
    },
    async doCheck() {
      if (!this.ispay || !this.paymentId) {
        this.$toasted.info("Please pay for the order first");
        return;
      }
      let index = this.selectItem.index;
      let currency = this.payType == 0 ? 'Stars' : 'TON';
      const checkRes = await this.checkPaymentSpins({
        index,
        paymentId: this.paymentId,
        currency
      });
      console.log("checkRescheckRescheckRes", checkRes);
      if (!checkRes) {
        this.taskInfo.paymentInfo[`p_${index}`].isLoading = false;
        return;
      }
      if (checkRes && checkRes.code === 302) {
        this.$toasted.info(checkRes.message);
        return;
      }
      this.ispay = false;
      this.popPromptShow = false;
      this.taskInfo.paymentInfo[`p_${index}`].isLoading = false;
      this.popMoreSpinsShow = false;
      this.taskInfo.popCoinAnim.icon = "SPINS";
      this.taskInfo.popCoinAnim.reward = this.selectItem.count;
      this.taskInfo.popCoinAnim.show = true;
    }
  },
  mounted() {}
};